import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	addDependencyLabel: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.dependencies.flyout.add-dependency.add-dependency-label',
		defaultMessage: '+ Add dependency',
		description: 'A label for button to add a new dependency to issue',
	},
});
